module.exports = __webpack_public_path__ + "img/Broken Prong.dfaf8579.png";